import clsx from "clsx";

import s from "./StatusBadge.module.css";

interface StatusBadgeProps {
  className?: string;
  status?: number;
}

const tone = (status?: number) => {
  if (!status) return "success";

  if (status >= 500) return "error";
  if (status >= 400) return "warning";
  if (status >= 300) return "info";
  return "success";
};

export const StatusBadge = ({ status, className }: StatusBadgeProps) => {
  return (
    <span className={clsx(s.badge, s[tone(status)], className)}>{status}</span>
  );
};
